const getValue = (value) => {
  const isValid = /^[a-zA-Z0-9]*$/.test(value)

  if(!isValid) return false

  return value.charAt(0)
}
const prevPin = (pincode) => {
  if (pincode.previousElementSibling !== null && pincode.value === "") {
    pincode.previousElementSibling.value = ""
    pincode.previousElementSibling.focus()
  }
}
const nextPin = (pincode) => {
  if (pincode.nextElementSibling !== null) pincode.nextElementSibling.focus()
}
const emptyPin = (pincode) => {
  if (pincode.value === "" && pincode.previousElementSibling !== null && pincode.previousElementSibling.value === "") prevPin(pincode)
  if (pincode.value !== "" && pincode.nextElementSibling !== null && pincode.nextElementSibling.value !== "") nextPin(pincode)
  if (pincode.value !== "" && pincode.nextElementSibling) nextPin(pincode)
}
const setValue = (pincode, k) => {
  const currentValue = getValue(pincode.value)

  if (k.key === "Backspace" && !currentValue) {
    prevPin(pincode)
    return
  }
  if (!currentValue) {
    pincode.value = ""
    return
  }

  pincode.value = currentValue
  nextPin(pincode)
}

const setHiddenInput = (pincodes) => {
  let pin = ''
  pincodes.forEach((input) => {
    pin += input.value
  })

  document.querySelector('[pincode]').value = pin
}

const Pincode = () => {
  const pincodes = document.querySelectorAll('.pincode input[type="text"]')

  pincodes.forEach((pincode, i) => {
    pincode.addEventListener('keydown', k => {
      setTimeout(() => {
        setValue(pincode, k)
        setHiddenInput(pincodes)
      }, 10)
    })
    pincode.addEventListener('focus', e => {
      emptyPin(pincode)
    })
  })
}

export default Pincode
